/** Runtime configuration. Everything is public — the frontend holds no secrets. */
export type AppEnv = 'development' | 'staging' | 'production' | 'test'

const VALID: readonly AppEnv[] = ['development', 'staging', 'production', 'test']

/**
 * ★ A BUILD WITHOUT `VITE_APP_ENV` IS PRODUCTION. It used to fall back to `development`, so a plain
 * `npm run build` on any host other than our Dockerfile shipped development behaviour — the
 * kitchen-sink route and the fake signup links — to real users. Missing or unknown now means
 * production for every Vite production build; only the dev server and the test runner default
 * lower. Staging must say `VITE_APP_ENV=staging` explicitly.
 */
function readAppEnv(raw: string | undefined): AppEnv {
  if (raw !== undefined && (VALID as readonly string[]).includes(raw)) return raw as AppEnv
  if (import.meta.env.MODE === 'test') return 'test'
  return import.meta.env.PROD ? 'production' : 'development'
}

export const env = {
  /** Always a same-origin path; see FRONTEND_PLAN §1.2. */
  apiBase: (import.meta.env.VITE_API_BASE ?? '/v1').replace(/\/+$/, ''),
  appEnv: readAppEnv(import.meta.env.VITE_APP_ENV),
  buildSha: import.meta.env.VITE_BUILD_SHA ?? 'dev',
} as const
